import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer">
      <span> &copy; Aaron Smith, 2020</span>
    </footer>
  );
}

export default Footer;
